import { Card, Col, Row } from "react-bootstrap";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { decryptFromStoreLoc } from "../../helper/localStore";
import { useContext } from "react";
import { CourseContext } from "../../context/CourseContext";
import { encryptAndStore } from "../../helper/sessionStore";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import

const Advantages = () => {
    const { t } = useTranslation("Advantages");

    const { setEmail } = useContext(CourseContext);
    const navigate = useNavigate();
    const features = [
        {
            icon: "/png/check-circle.png",
            title: t("desc1"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc2"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc3"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc4"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc5"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc6"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc7"),
            useImage: true,
        },
        {
            icon: "/png/check-circle.png",
            title: t("desc8"),
            useImage: true,
        },
    ];

    const pricingPlans = [
        {
            title: t("free_plan_title"),
            price: "€0",
            descriptions: [
                t("free_plan_feature_1"),
                t("free_plan_feature_2"),
                t("free_plan_feature_3"),
                t("free_plan_feature_4"),
            ],
            variant: "primary",
            priceDescription: t("free_plan_per"),
            cardClass: "starter",
            textWhite: false,
        },
        {
            title: t("full_access_plan_title"),
            price: "€3",
            descriptions: [
                t("full_access_plan_feature_1"),
                t("full_access_plan_feature_2"),
                t("full_access_plan_feature_3"),
                t("full_access_plan_feature_4"),
                t("full_access_plan_feature_5"),
            ],
            variant: "warning",
            priceDescription: t("full_access_plan_per"),
            cardClass: "business",
            textWhite: true,
        },
        {
            title: t("enterprise_plan_title"),
            price: t("enterprise_plan_price"),
            descriptions: [
                t("enterprise_plan_feature_1"),
                t("enterprise_plan_feature_2"),
                t("enterprise_plan_feature_3"),
                t("enterprise_plan_feature_4"),
                t("enterprise_plan_feature_5"),
            ],
            variant: "warning",
            priceDescription: t("enterprise_plan_per"),
            cardClass: "enterprise",
            textWhite: true,
        },
    ];

    const handleRegister = () => {
        const data = decryptFromStoreLoc("AIUserData");
        if (data) {
            setEmail(data.email);
            encryptAndStore("role", 12);
            encryptAndStore("emailUserName", data.name);
            setTimeout(() => {
                navigate("/user-details");
            }, 1000);
        } else {
            navigate("/sign-up");
        }
    };

    return (
        <>
            <Header />
            <section className="advantages_main">
                <div className="container">
                    <div className="unicorso-app">
                        <div className="content-area">
                            <div className="hero-banner">
                                <Row>
                                    <Col
                                        md={6}
                                        className="d-flex flex-column justify-content-center order-2 order-md-1"
                                    >
                                        <h1>{t("whyunicorso")}</h1>
                                    </Col>
                                    <Col
                                        md={6}
                                        className="position-relative d-flex justify-content-end order-1 order-md-2"
                                    >
                                        <img
                                            src="/png/advantages.png"
                                            alt=""
                                            className="hero-image"
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <Row className="features-grid">
                                {features.map((feature, index) => (
                                    <Col
                                        className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-12 mb-4"
                                        key={index}
                                    >
                                        <div className="text-center">
                                            <div className="feature-icon-wrapper">
                                                {feature.useImage ? (
                                                    <img
                                                        src={feature.icon}
                                                        alt=""
                                                    />
                                                ) : (
                                                    <div className="feature-icon">
                                                        <i className="bi bi-check"></i>
                                                    </div>
                                                )}
                                            </div>
                                            <h3 className="feature-title">
                                                {feature.title}
                                            </h3>
                                            {/* <p className="feature-title">
                                                {feature.subtitle}
                                            </p> */}
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                            <div className="pricing-section">
                                <div className="row mb-4">
                                    <div className="col-xl-9">
                                        <h2 className="mb-1">
                                            {t("chooseyoursubscriptionplan")}
                                        </h2>
                                        <p>
                                            {t(
                                                "chooseyoursubscriptionplandescription"
                                            )}
                                        </p>
                                    </div>
                                </div>

                                <Row className="mb-0 mb-md-4">
                                    {pricingPlans.map((plan, index) => (
                                        <Col
                                            className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12 mb-4"
                                            key={index}
                                        >
                                            <Card
                                                className={`pricing-card ${plan.cardClass}`}
                                            >
                                                <Card.Body
                                                    className={`text-center px-4 py-4 py-md-5 ${
                                                        plan.textWhite
                                                            ? "text-white"
                                                            : ""
                                                    }`}
                                                >
                                                    <h3 className="plan-title">
                                                        {plan.title}
                                                    </h3>
                                                    {Array.isArray(
                                                        plan.descriptions
                                                    ) &&
                                                        plan.descriptions.map(
                                                            (desc, i) => (
                                                                <div
                                                                    className="d-flex align-items-start gap-2 mt-2"
                                                                    key={i}
                                                                >
                                                                    <img
                                                                        src={
                                                                            plan.textWhite
                                                                                ? "/png/check-arrow-white.png"
                                                                                : "/png/check-arrow.png"
                                                                        }
                                                                        width={
                                                                            24
                                                                        }
                                                                        height={
                                                                            24
                                                                        }
                                                                        alt=""
                                                                    />
                                                                    <p className="plan-description mb-0">
                                                                        {desc}
                                                                    </p>
                                                                </div>
                                                            )
                                                        )}
                                                </Card.Body>
                                                <Card.Footer className="bg-transparent border-0 justify-content-center d-flex pb-5">
                                                    <div>
                                                        <div
                                                            className={`plan-price text-center  ${
                                                                plan.textWhite
                                                                    ? "text-white"
                                                                    : ""
                                                            }`}
                                                        >
                                                            {plan.price}
                                                        </div>
                                                        <p
                                                            className={`plan-description mb-0 text-center ${
                                                                plan.textWhite
                                                                    ? "text-white"
                                                                    : ""
                                                            }`}
                                                        >
                                                            {
                                                                plan.priceDescription
                                                            }
                                                        </p>
                                                        <button
                                                            className="mt-5 d-flex m-auto"
                                                            onClick={
                                                                handleRegister
                                                            }
                                                        >
                                                            {t("plan_cta")}
                                                        </button>
                                                    </div>
                                                </Card.Footer>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>

                                <div className="price_bottom_description mt-4">
                                    <h4>{t("footer_title")}</h4>
                                    <h5>
                                        {t("footer_desc1_1")}{" "}
                                        <span className="fw-600">
                                            {t("footer_desc1_2")}
                                        </span>{" "}
                                       {t("footer_desc1_3")}{" "}
                                        <span className="fw-600">
                                            {" "}
                                            {t("footer_desc1_4")}
                                        </span>
                                    </h5>
                                    <p>
                                        {t("footer_desc2")}
                                    </p>
                                    <button className="signup-button mt-2">
                                        {t("footer_cta")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Advantages;
